import { lazy } from "react";
import AccountIcon from "../components/svg/AccountIcon";
import ApiDocIcon from "../components/svg/ApiDocIcon";
import AttackSurfaceIcon from "../components/svg/AttackSurfaceIcon";
import CustomersIcon from "../components/svg/CustomersIcon";
import DarkWebExposureIcon from "../components/svg/DarkWebExposureIcon";
import HomeIcon from "../components/svg/HomeIcon";
import NavLeakedPasswordIcon from "../components/svg/NavLeakedPasswordIcon";
import RecommendationsIcon from "../components/svg/RecommendationsIcon";
import { ModuleLink } from "../types/components/ModuleLink";
import { ModulesName } from "../types/enums/ModulesName";
import { ChecklistShieldIcon } from "../components/svg/ChecklistShieldIcon";

// Lazy Loading | Code Splitting Components
const Home = lazy(() => import("../pages/dashboard"));
const AccountSettings = lazy(() => import("../pages/profile"));
const LeakedPasswords = lazy(() => import("../pages/leaked_passwords"));
const AttackSurface = lazy(() => import("../pages/attack_surface"));
const DarkWebExposure = lazy(() => import("../pages/dark_web_exposure"));
const Recommendations = lazy(() => import("../pages/recommendations"));
const InternalAssessment = lazy(() => import("../pages/internal_assessment"));
const PortfolioView = lazy(() => import("../pages/portfolio_view"));
const SwaggerUI = lazy(() => import("swagger-ui-react"));
// import InternalArchitecture from './pages/internal_architecture'; // In Construction...

export const moduleLinks: ModuleLink[] = [
  {
    path: "/",
    name: ModulesName.DASHBOARD,
    Component: Home,
    Icon: HomeIcon,
    fromSideBar: true,
    onPlan: true,
  },
  {
    path: "/leaked-passwords",
    name: ModulesName.LEAKED_PASSWORDS,
    Component: LeakedPasswords,
    Icon: NavLeakedPasswordIcon,
    fromSideBar: true,
    onPlan: true,
  },
  {
    path: "/attack-surface",
    name: ModulesName.ATTACK_SURFACE,
    Component: AttackSurface,
    Icon: AttackSurfaceIcon,
    fromSideBar: true,
    onPlan: true,
  },
  {
    path: "/dark-web-exposure",
    name: ModulesName.DARK_WEB_EXPOSURE,
    Component: DarkWebExposure,
    Icon: DarkWebExposureIcon,
    fromSideBar: true,
    onPlan: true,
  },
  {
    path: "/recommendations",
    name: ModulesName.RECOMMENDATIONS,
    Component: Recommendations,
    Icon: RecommendationsIcon,
    fromSideBar: true,
    onPlan: true,
  },
  {
    path: "/security-checklist",
    name: ModulesName.SECURITY_CHECKLIST,
    Component: InternalAssessment,
    Icon: ChecklistShieldIcon,
    fromSideBar: true,
    onPlan: true,
  },
  {
    path: "/portfolio-view",
    name: ModulesName.PORTFOLIO_VIEW,
    Component: PortfolioView,
    Icon: CustomersIcon,
    fromSideBar: true,
    onPlan: false,
    default: true,
  },
  {
    path: "/account-settings",
    name: ModulesName.ACCOUNT_SETTINGS,
    Component: AccountSettings,
    Icon: AccountIcon,
    fromSideBar: false,
    onPlan: false,
  },
  {
    path: "/api-resources",
    name: ModulesName.API_RESOURCES,
    Component: SwaggerUI,
    options: { url: "https://preprod-api.cypherleak.com/v1/swagger-config" },
    Icon: ApiDocIcon,
    fromSideBar: true,
    onPlan: true,
  },
  // {
  //   path: "/internal-architecture",
  //   name: ModulesName.INTERNAL_ARCHITECTURE,
  //   Icon: InternalArchitectureIcon,
  //   fromSideBar: true,
  //   onPlan: false,
  // },
];

